import type {labelProviderInterface} from '../../../../LabelProviderInterface';

export const DUMMY_URL = {
  se: 'https://www.se.com/$CC/$LL/work/support/myschneider/',
  mySE: 'https://www.se.com/myschneider/'
};

export const dummyBannerConfig = (brand: string, country: string, language: string, labelProvider: labelProviderInterface) => {
    const brandName = brand?.toLowerCase();
    switch (brandName) {
    case 'se':
      return {
        widgetName: 'Dummy banner',
        titleValue: labelProvider('offsite.dummy-banner.title', 'Access mySchneider, your personalized digital experience.'),
        ctaButtonText: labelProvider('offsite.dummy-banner.button', 'Create your account'),
        subtitleValue: labelProvider('offsite.dummy-banner.description', 'Get access to all resources, tools, and expert support with a single login to save time and operate your business efficiently.'),
        keywords: [],
        titleUrl: DUMMY_URL.se.replace('$CC', country).replace('$LL', language),
        links: [],
        tabs: [],
      };
    }
};
